import React from 'react'

function Privacy() {
  return (
    <> <div className="mb-5"><h6># Privacy Policy for DibruGo
      <br/>
  <br/>
Effective Date: 17 March 2026
<br/>
Welcome to **DibruGo** ("we," "our," or "us"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website **https://dibrugo.com** and use our services.
<br/>
By using our website and services, you agree to the terms of this Privacy Policy.
<br/>
---
<br/>
## 1. Information We Collect
<br/>
We may collect the following types of information:
<br/>
### a) Personal Information
<br/>
* Name
* Phone number
* Email address
* Pickup and drop locations
* Payment details (if applicable)
<br/>
### b) Non-Personal Information
<br/>
* Browser type
* IP address
* Device information
* Website usage data (pages visited, time spent, etc.)
<br/>
---
<br/>
## 2. How We Use Your Information
<br/>
We use your information to:
<br/>
* Provide and manage taxi and ride booking services
* Process bookings and payments
* Communicate with you (booking confirmations, OTPs, support)
* Improve our website and services
* Prevent fraud and enhance security
<br/>
---
<br/>
## 3. Sharing Your Information
<br/>
We do not sell your personal data. However, we may share your information with:
<br/>
* Drivers or service providers to fulfill your ride
* Payment gateways for secure transactions
* Legal authorities if required by law
<br/>
---
<br/>
## 4. Data Security
<br/>
We take reasonable steps to protect your personal information from unauthorized access, misuse, or disclosure. However, no online system is 100% secure.
<br/>
---
<br/>
## 5. Cookies and Tracking Technologies
<br/>
We may use cookies to:
<br/>
* Improve user experience
* Analyze website traffic
* Remember user preferences
<br/>
You can disable cookies through your browser settings.
<br/>
---
<br/>
## 6. Third-Party Services
<br/>
Our website may contain links or integrations with third-party services (such as payment gateways or maps). We are not responsible for their privacy practices.
<br/>
---
<br/>
## 7. Your Rights
<br/>
You have the right to:
<br/>
* Access your personal data
* Request correction or deletion
* Withdraw consent (where applicable)
<br/>
To exercise these rights, contact us at the details below.
<br/>
---
<br/>
## 8. Children's Privacy
<br/>
Our services are not intended for individuals under the age of 18. We do not knowingly collect data from children.
<br/>
---
<br/>
## 9. Changes to This Privacy Policy
<br/>
We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised effective date.
<br/>
---
<br/>
## 10. Contact Us
<br/>
If you have any questions about this Privacy Policy, you can contact us:
<br/>
**Business Name:** DibruGo
**Website:** https://dibrugo.com
**Email:** support.dibrugo.com
**Phone:** [Insert Phone Number]
<br/>
---
<br/>
## 11. Consent
<br/>
By using our website, you consent to our Privacy Policy and agree to its terms.
<br/>
---
<br/>
*This Privacy Policy is designed for DibruGo taxi and self-drive services operating in India.*
</h6></div></>
  )
}

export default Privacy